import { reviewPoints } from '@/mocks/seo-content';
import { mainSiteUrl } from '@/mocks/categories';

const featureComparison = [
  { feature: 'International Shipping', sugargoo: 'Available worldwide', traditional: 'Limited regions' },
  { feature: 'Warehouse Service', sugargoo: 'Free 180-day storage', traditional: 'Not available' },
  { feature: 'QC Photos', sugargoo: 'Included with every order', traditional: 'Not provided' },
  { feature: 'Product Sourcing', sugargoo: 'Multi-platform support', traditional: 'Single platform only' },
];

export default function ReviewSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            Authority Review
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            Sugargoo Review 2026: Everything You Need To Know
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            An honest, comprehensive look at how Sugargoo works and why shoppers worldwide trust this platform.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-10">
          {reviewPoints.map((point) => (
            <div key={point.title} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{point.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{point.content}</p>
            </div>
          ))}
        </div>

        <div className="rounded-xl border border-background-200/70 overflow-hidden mb-8">
          <h3 className="text-sm font-semibold text-foreground-800 px-5 py-4 bg-background-200/50">Feature Comparison</h3>
          <table className="w-full">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left px-5 py-3 text-xs font-medium text-foreground-500">Feature</th>
                <th className="text-left px-5 py-3 text-xs font-medium text-primary-600">Sugargoo</th>
                <th className="text-left px-5 py-3 text-xs font-medium text-foreground-500">Traditional Shopping</th>
              </tr>
            </thead>
            <tbody>
              {featureComparison.map((row) => (
                <tr key={row.feature} className="border-b border-background-100 last:border-0">
                  <td className="px-5 py-3 text-sm text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3 text-sm text-primary-700 font-medium">{row.sugargoo}</td>
                  <td className="px-5 py-3 text-sm text-foreground-500">{row.traditional}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            Visit Sugargoo Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}